import React, { useState, useEffect } from 'react';
import '../catalogue/styles.css';
import img from '../../assets/images/items/img3.jpg'
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
// import MenuIcon from '@rsuite/icons/Menu';
// import GridIcon from '@rsuite/icons/Grid';
// import { Icon } from '@rsuite/icons';
import {
  Button,
  Form,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  TagPicker,
  Container,
  Modal,
  Toggle,
  IconButton,
  Table,
  CellProps,
  Dropdown,
  Placeholder,
  Input,
  SelectPicker,
  FlexboxGrid,
  Col,
  Checkbox,
  Message,
  Loader,
  Pagination,
  useToaster
} from 'rsuite';
import { Icon, Paragraph } from '@rsuite/icons';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import TrashIcon from '@rsuite/icons/Trash';
import CloseIcon from '@rsuite/icons/Close';
import { mockUsers } from '@/data/mock';
import SendIcon from '@rsuite/icons/Send';
import ProjectIcon from '@rsuite/icons/Project';
import CloseOutlineIcon from '@rsuite/icons/CloseOutline';
import CheckOutlineIcon from '@rsuite/icons/CheckOutline';
import { useLocation } from 'react-router-dom';


type YourDataType = {
  id: number;
  attributes: {
    CoverImage: any;
    ProductName: string;
    ProductId: string;
    ProductType: string;
    SizeUnit: string;
    Length: number;
    Width: number;
    Color: string;
    Finish: string;
    // Add other attribute properties here
  };
};
import TreemapIcon from '@rsuite/icons/Treemap';
import DrawerViewe from './DrawerViewe';


import DrawerLink from './DrawerLink';

const { Column, HeaderCell, Cell } = Table;

export const ImageCell = ({ rowData, dataKey, ...props }: CellProps) => (
  <Cell {...props} style={{ padding: 0 }}>
    <div
      style={{
        width: 40,
        height: 40,
        background: '#f5f5f5',
        borderRadius: 6,
        marginTop: 2,
        overflow: 'hidden',
        display: 'inline-block'
      }}
    >
      <img src={rowData[dataKey!]} width="40" />
    </div>
  </Cell>
);


const EditableCell = ({ rowData, dataKey, onChange, ...props }) => {
  const editing = rowData.status === 'EDIT';
  if (dataKey === "ProductType" || dataKey === "category" || dataKey === "unit" || dataKey === "Color" || dataKey === "Finish") {
    return (
      <Cell {...props} className={editing ? "table-content-editing" : ""}>
        {editing ? (
          <span className="table-content-edit-span">{rowData[dataKey]}</span>
        ) : (
          <SelectPicker
            defaultValue={rowData[dataKey]}
            onChange={event => {
              onChange && onChange(rowData.id, dataKey, event.target.value);
            }} data={[]} />
        )}
      </Cell>
    );
  } else if (dataKey === "id" || dataKey === "CBM") {
    return (
      <Cell {...props} className={editing ? 'table-content-editing' : ''}>
        {editing ? (
          <span className="table-content-edit-span">{rowData[dataKey]}</span>
        ) : (
          <input
            className="rs-input"
            readOnly
            defaultValue={rowData[dataKey]}
            onChange={event => {
              onChange && onChange(rowData.id, dataKey, event.target.value);
            }}
          />
        )}
      </Cell>
    );
  } else {
    return (
      <Cell {...props} className={editing ? 'table-content-editing' : ''}>
        {editing ? (
          <span className="table-content-edit-span">{rowData[dataKey]}</span>
        ) : (
          <input
            className="rs-input"
            defaultValue={rowData[dataKey]}
            onChange={event => {
              onChange && onChange(rowData.id, dataKey, event.target.value);
            }}
          />
        )}
      </Cell>
    );
  };
}


interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}

interface MetaData {
  pagination: PaginationData;
}
let catalogueCodeCounter = 1;

const EditDetails = () => {

 
  const ipp = 'http://192.168.1.23:1337';

  const { Column, HeaderCell, Cell } = Table;


  const CompactCell = props => <Cell {...props} style={{ padding: 4 }} />;
  const CompactHeaderCell = props => <HeaderCell {...props} style={{ padding: 4 }} />;

  const defaultColumns = [
    {
      key: 'id',
      label: <b>Sr.No.</b>,
      fixed: true,
      width: 60
    },
    {
      key: 'Image',
      label: 'Image',
      width: 150,
      headerCell: <Table.HeaderCell flexGrow={1}><b>Image</b></Table.HeaderCell>,
      cell: <Table.Cell >{(rowData) => (
        <img
          src={`${ip}${rowData.attributes.CoverImage.data.attributes.url}`}
          alt="User Image"
          style={{ width: 50, height: 50, marginTop: '-16px' }}
        />
      )}</Table.Cell>
    },
    {
      key: 'ProductId',
      label: 'Alias Code',
      width: 150,
      headerCell: <Table.HeaderCell flexGrow={1}><b>Alias Code</b></Table.HeaderCell>,
      cell: <Table.Cell dataKey="attributes.ProductId" />
    },
    {
      key: 'SizeUnit',
      label: 'Size Unit',
      width: 150,
      headerCell: <Table.HeaderCell flexGrow={1}><b>SizeUnit</b></Table.HeaderCell>,
      cell: <Table.Cell dataKey="attributes.SizeUnit" />
    },
    {
      key: 'length',
      label: 'Length',
      width: 100,
      headerCell: <Table.HeaderCell flexGrow={1}><b>Length</b></Table.HeaderCell>,
      cell: <Table.Cell dataKey="attributes.Length" />
    },
    {
      key: 'width',
      label: 'Width',
      width: 100,
      headerCell: <Table.HeaderCell flexGrow={1}><b>Width</b></Table.HeaderCell>,
      cell: <Table.Cell dataKey="attributes.Width" />
    },
    {
      key: 'height',
      label: 'Height',
      width: 100,
      headerCell: <Table.HeaderCell flexGrow={1}><b>Height</b></Table.HeaderCell>,
      cell: <Table.Cell dataKey="attributes.Height" />
    },
    {
      key: 'Description',
      label: 'Description',
      width: 100,
      headerCell: <Table.HeaderCell flexGrow={1}><b>Description</b></Table.HeaderCell>,
      cell: <Table.Cell dataKey="attributes.Description" />
    },
    {
      key: 'ColorName',
      label: 'Color',
      width: 150,
      headerCell: <Table.HeaderCell flexGrow={1}><b>Color</b></Table.HeaderCell>,
      cell: <Table.Cell dataKey="attributes.ColorName" />
    },
    {
      key: 'FinishName',
      label: 'Finish',
      width: 100,
      headerCell: <Table.HeaderCell flexGrow={1}><b>Finish</b></Table.HeaderCell>,
      cell: <Table.Cell dataKey="attributes.FinishName" />
    },
    {
      key: 'ProductCost',
      label: 'Product Cost',
      width: 100,
      headerCell: <Table.HeaderCell flexGrow={1}><b>Product Cost</b></Table.HeaderCell>,
      cell: <Table.Cell dataKey="attributes.ProductCost" />
    },
    {
      key: 'cbm',
      label: 'CBM',
      width: 100,
      headerCell: <Table.HeaderCell flexGrow={1}><b>CBM</b></Table.HeaderCell>,
      cell: <Table.Cell dataKey="attributes.cbm" />
    },
    {
      key: 'Action',
      label: 'Action',
      width: 100,
      headerCell: <Table.HeaderCell flexGrow={1}><b>Action</b></Table.HeaderCell>,
      cell: <Table.Cell style={{ padding: '6px' }}>
        {(rowData) => (
          <IconButton
            size="sm"
            icon={<TrashIcon />}
            active
            onClick={() => handleDeleteRow(rowData.id)}

          />
        )}
      </Table.Cell>
    }

  ];


  const [placement, setPlacement] = React.useState('topEnd');
  const toaster = useToaster();
  const message = (
    <Message showIcon type='success' closable>
      Catalogue Generate successfully.
    </Message>
  );

  const [open1, setOpen1] = React.useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => {
    setOpen1(false);
    
  }
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [open2, setOpen2] = React.useState(false);
  const handleOpen2 = () => setOpen2(true);
  const handleClose2 = () => {
    setOpen2(false);
    
  }



  const [showDrawer2, setShowDrawer2] = useState(false);
  const [showDrawer3, setShowDrawer3] = useState(false);
  const [loading, setLoading] = useState(true);
  const [compact, setCompact] = React.useState(true);
  const [noData, setNoData] = React.useState(false);
  const [autoHeight, setAutoHeight] = React.useState(true);
  const [columnKeys, setColumnKeys] = React.useState(defaultColumns.map(column => column.key).filter(key => key !== 'ProductCost'));
  const columns = defaultColumns.filter(column => columnKeys.some(key => key === column.key));
  const CustomCell = compact ? CompactCell : Cell;
  const CustomHeaderCell = compact ? CompactHeaderCell : HeaderCell;

  useEffect(() => {
    // Simulating an asynchronous data fetch
    setTimeout(() => {
      setLoading(false);
    }, 1000); // Simulating a 2-second delay
  }, []);

  // Fetch Data from API Start
  const [meta123, setMeta123] = useState<MetaData>();
  const [data123, setData123] = useState<YourDataType[]>([]);
  const [data1234, setData1234] = useState<YourDataType[]>([]);
  const [editingRowId, setEditingRowId] = useState<number | null>(null);
  const [editedData, setEditedData] = useState<Partial<YourDataType>>({} as Partial<YourDataType>);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 25,
    pageCount: 1,
    total: 0,
  });
  useEffect(() => {
    fetchData();
  }, [data1234]);
  const fetchData = async () => {
    const response = await fetch(`${ipp}/api/products?populate=*&pagination[page]=${activePage}`);
    const json = await response.json();
    const filtereddData = json.data.filter(item => selectedItemsArray.includes(String(item.id)));
    setData123(json.data);
    setMeta123(json.meta);
    setPagination(json.meta.pagination);
    setData1234(filtereddData);
  };
  const [activePage, setActivePage] = React.useState(1);
  //  Fetch Data from API End


  const handleDeleteRow = (id) => {
    setData1234(prevData => prevData.filter(item => item.id !== id));
  };

  const ip = ipp;
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const selectedItems = searchParams.get('selectedItems') || '';
  const selectedItemsArray = selectedItems.split(',');
  // Filter the data based on the selected items
  const [filteredData, setFilteredData] = useState([]);


  useEffect(() => {
    setFilteredData(data123.filter((item) => selectedItemsArray.includes(String(item.id))));
  }, [data123, selectedItemsArray]);

  const [selectedItemsToAdd, setSelectedItemsToAdd] = useState([]);
  const handleCheckboxChange = (value, checked) => {
    if (checked) {
      setSelectedItemsToAdd((prevSelectedItems) => [...prevSelectedItems, value]);
    } else {
      setSelectedItemsToAdd((prevSelectedItems) => prevSelectedItems.filter((item) => item !== value));
    }
  };

  const handleSelectAll = (value, checked) => {
    if (checked) {
      const allItemIds = data123.map((item) => String(item.id));
      setSelectedItemsToAdd(allItemIds);
    } else {
      setSelectedItemsToAdd([]);
    }
  };

  const handleAddItems = () => {
    //   const newFilteredData = data123.filter(item => selectedItems.includes(String(item.id)));
    // setFilteredData(newFilteredData);

    const newFilteredData = [
      ...filteredData,
      ...data123.filter((item) => selectedItemsToAdd.includes(String(item.id))),
    ];
    setFilteredData(newFilteredData);
    // Close the modal or show a success message
    handleClose2();
  };


  const handleToggleChange = checked => {
    if (checked) {
      // Show the 'ProductCost' column
      setColumnKeys(prevColumnKeys => [...prevColumnKeys, 'ProductCost']);
    } else {
      // Hide the 'ProductCost' column
      setColumnKeys(prevColumnKeys => prevColumnKeys.filter(key => key !== 'ProductCost'));
    }
  };

  const GotoProductDesignwithId = useNavigate();
  const uddateProduct = (data) => {
    if (cata.catalogueName==='') {
      
      
    }else{
      const encodedData = encodeURIComponent(JSON.stringify(data));
      GotoProductDesignwithId(`/generate-catalogue?data=${encodedData}`);
    }
  };


  

  const [cata, setCata] = useState({
    catalogueName: "",
    BuyerCompany: "",
    BuyerEmail: "",
    CatalogueCode: "",
    CatalogueProduct: [
      {
         
          CatalogProduct: "",
          CatalogCode: ""
      },
  ]
  });

  const [cataloguedata, setCataloguedata] = React.useState([]);
  useEffect(() => {
    fetchData0();
  }, []);
  const fetchData0 = async () => {
    const response = await fetch(`${ipp}/api/catalogues`);
    const json = await response.json();
    setCataloguedata(json.data);
  };

  const generateCatalogue = () => {
    const categoryCount = cataloguedata.length;
    const nextCode = categoryCount + 1;
    return `CATLG-${nextCode.toString().padStart(3, "0")}`;
  };

  const url2 = `${ipp}/api/catalogues`;
  const submit = e => {
      e.preventDefault();
      if(cata.catalogueName===''){
        toaster.push(<Message showIcon type='error' >
        Please Enter Catalogue Name
      </Message>, { placement: 'topEnd' });
      }else{
      const nextCatalogueCode = generateCatalogue();
      const formData = new FormData();
      
      // const selectedProductNames = data1234.map((item) => item.attributes.ProductName);

      // const updatedCatalogue = {
      //   ...cata,
      //   CatalogueCode: nextCatalogueCode,
      //   CatalogueProduct: selectedProductNames.map((productName) => ({
      //     CatalogProduct: productName,
      //     CatalogCode: ""
      //   }))
      // };
    
      // formData.append("data", JSON.stringify(updatedCatalogue));

      const selectedProductCodes = data1234.map((item) => item.attributes.ProductId);

  const updatedCatalogue = {
    ...cata,
    CatalogueCode: nextCatalogueCode,
    CatalogueProduct: selectedProductCodes.map((productid) => ({
      CatalogProduct: productid,
      CatalogCode: nextCatalogueCode 
    }))
  };

  formData.append("data", JSON.stringify(updatedCatalogue));
      
      fetch(url2, {
        method: 'POST',
        body: formData,
      })
        .then(response => response.json())
        .then(data => {
          console.log(data);
          // Refresh page after 2 seconds (3000 milliseconds)
          // setTimeout(() => {
          //   window.location.reload();
          // }, 2000);
        })
        .catch(error => console.error(error));
        catalogueCodeCounter++;
      toaster.push(<Message showIcon type='success' >
        Saved Successfully
      </Message>, { placement: 'topEnd' });
      
    }
  };

  const handleInputChange = (inputName, event, index) => {
    const value = event.target ? event.target.value : event;
    

    setCata({ ...cata, [inputName]: value });

  }
 const datattt = ()=>{
  submit(event);
  uddateProduct(data1234);
 }
 const [companydataa, setCompanydataa] = React.useState([]);
  useEffect(() => {
    fetchData6();
  }, []);
  const fetchData6 = async () => {
    try {
      const response = await fetch(`${ip}/api/buyer-companies`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.companynm,
        value: item.attributes.companynm,
      }));
      setCompanydataa(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const [buyeerdata, setBuyeerdata] = React.useState([]);
  useEffect(() => {
    fetchData3();
  }, []);
  const fetchData3 = async () => {
    try {
      const response = await fetch(`${ip}/api/buyer-details`);
      const json = await response.json();
      const processedData = json.data.map((item) => ({
        label: item.attributes.buyernm,
        value: item.attributes.buyercode,
      }));
      setBuyeerdata(processedData);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  return (
    <>
      <Container className='main'>
        <Stack className="table-toolbar" justifyContent="space-between">
          <Stack direction='column' alignItems='flex-start'>
            <Stack direction='column' alignItems='flex-start'>
              <h3 className="title">Catalogues</h3>
              <Breadcrumb>
                <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                {/* <Breadcrumb.Item href="/catalogue">Create Catalogue</Breadcrumb.Item> */}
                <Breadcrumb.Item href="/selection">Select Product</Breadcrumb.Item>
                <Breadcrumb.Item active>Edit Details</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>


          </Stack>

          <Stack direction='column' alignItems='flex-end' spacing={53}>
            <Stack direction='row' spacing={5}>
              {/* <InputGroup inside >
                <Input placeholder="Search" value={searchKeyword} onChange={setSearchKeyword} />
                <InputGroup.Addon>
                  <SearchIcon />
                </InputGroup.Addon>
              </InputGroup>
              <Button appearance="default" active>
                <SearchIcon /> Smart Search
              </Button> */}
            </Stack>

            {/* <div>
        <h6>Selected Items:</h6>
        <ul>
          {selectedItems.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div> */}
            <Stack spacing={10}>
              <label>Show Product Cost: </label>
              <Toggle checked={columnKeys.includes('ProductCost')} onChange={handleToggleChange} />
              <Button appearance="subtle" active onClick={handleOpen2}>
                Add More Product
              </Button>
              <Button appearance="ghost" color='cyan' onClick={handleOpen}>
                Customize Table
              </Button>
              <Dropdown title="Create" placement="bottomEnd" color='cyan' appearance='primary'>
                {/* <Dropdown.Item ><Stack spacing={30}><Stack direction='column' alignItems='flex-start'><b>Collection</b><p>Get this catalouge approve by admin</p></Stack><Stack><Icon as={TreemapIcon} /></Stack></Stack></Dropdown.Item> */}
                <Dropdown.Item onClick={handleOpen1}><Stack spacing={80}><Stack direction='column' alignItems='flex-start'><b>Catalogue Draft</b><p>Create catalogue for a buyer</p></Stack><Stack><Icon as={ProjectIcon} /></Stack></Stack></Dropdown.Item>
                {/* <Dropdown.Item ><Stack spacing={145}><Stack direction='column' alignItems='flex-start'><b>Catalogue Publish</b><p>Publish catalogue</p></Stack><Stack><Icon as={SendIcon} /></Stack></Stack></Dropdown.Item> */}
              </Dropdown>
              {/* <Button color="cyan" appearance="primary">
                Continue
            </Button> */}
            </Stack>
          </Stack>
        </Stack>
        <Divider className='divide' />
        <div className="row">
          <Panel>
          <b>{data1234.length} Products</b>
            <Table
              rowHeight={60}
              data={noData ? [] : data1234}
              height={400}
              rowKey="id"
              loading={loading}
              bordered
            >

              {defaultColumns.map(column => {
                if (columnKeys.includes(column.key)) {
                  const { key, label, headerCell, cell, ...rest } = column;
                  return (
                    <Table.Column {...rest} key={key}>
                      {headerCell || <CustomHeaderCell>{label}</CustomHeaderCell>}
                      {cell || <CustomCell dataKey={key} />}
                    </Table.Column>
                  );
                }
                return null;
              })}

            </Table>
            <Stack justifyContent='flex-end'>
            {pagination.pageCount > 1 && (
          <Pagination
        prev
        last
        next
        first
        size="xs"
        total={pagination.total}
        limit={pagination.pageSize}
        activePage={pagination.page}
        onChangePage={setActivePage}
      />
            )}
      </Stack>
          </Panel>
        </div>
        <Modal open={open} onClose={handleClose} backdrop={'static'}>
          <Modal.Header>
            <Modal.Title><h3 className="title">Customize Details</h3></Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <TagPicker
              data={defaultColumns}
              labelKey="label"
              valueKey="key"
              value={columnKeys}
              onChange={setColumnKeys}
              cleanable={false}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={handleClose} appearance="primary" color='cyan'>
              Done
            </Button>

          </Modal.Footer>
        </Modal>
        <Modal open={open1} onClose={handleClose1} backdrop={'static'} size="lg">
          <Modal.Header>
            <Modal.Title><h3 className="title">Confirm all Details</h3></Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <Form fluid>
              <FlexboxGrid >
            <FlexboxGrid.Item as={Col} colspan={24} md={12} style={{marginBottom:'20px'}}>
              <Form.Group controlId="name-1">
                <Form.ControlLabel>Catalogue Name</Form.ControlLabel>
                <Input id='catalogueName' name="catalogueName" value={cata && cata.catalogueName ? cata.catalogueName : ''} onChange={value => handleInputChange('catalogueName', value, 0)} />
              </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12} style={{marginBottom:'20px'}}>
              <Form.Group controlId="name-1">
                <Form.ControlLabel>Buyer Name</Form.ControlLabel>
                <SelectPicker data={buyeerdata}
                 
                block/>
              </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Form.Group controlId="name-1">
                  <Form.ControlLabel>Buyer Company</Form.ControlLabel>
                  <SelectPicker data={companydataa} labelKey="label"
                      valueKey="value" id='BuyerCompany' name="BuyerCompany" value={cata && cata.BuyerCompany ? cata.BuyerCompany : ''} onChange={value => handleInputChange('BuyerCompany', value, 0)} block />
                </Form.Group>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12}>
                <Form.Group controlId="email-1" >
                  <Form.ControlLabel>Buyer Email ID (optional)</Form.ControlLabel>
                  <Input id='BuyerEmail' name="BuyerEmail" value={cata && cata.BuyerEmail ? cata.BuyerEmail : ''} onChange={value => handleInputChange('BuyerEmail', value, 0)} />
                </Form.Group>
              </FlexboxGrid.Item>
              </FlexboxGrid>
              {/* <FlexboxGrid.Item as={Col} colspan={24} md={12} style={{ marginTop: 20 }}>
                <Panel bordered>
                  <Stack justifyContent='space-between'>
                    <b>Presentation template</b>
                    <Button appearance="ghost" color='cyan' onClick={() => setShowDrawer3(true)}>
                      Update
                    </Button>
                  </Stack>
                  <Stack direction='column' alignItems='flex-start'>
                    <label>Default template selected</label>
                    <img src={img} className='imgp' />
                    <label>Template Design for your requirement</label>
                  </Stack>
                </Panel>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item as={Col} colspan={24} md={12} style={{ marginTop: 20 }}>
                <Panel bordered>
                  <Stack justifyContent='space-between'>
                    <b>Link Settings</b>
                    <Button onClick={() => setShowDrawer2(true)} appearance="ghost" color='cyan'>
                      Update
                    </Button>
                  </Stack>
                  <Stack direction='column' alignItems='flex-start'>
                    <label>Recommended</label>
                    <Stack direction='row' spacing={10}>
                      <Icon as={CloseOutlineIcon}></Icon><label>Email ID in NOT require to view catalogue</label>
                    </Stack>
                    <Stack direction='row' spacing={10}>
                      <Icon as={CheckOutlineIcon}></Icon><label>You can download PPT</label>
                    </Stack>
                    <Stack direction='row' spacing={10}>
                      <Icon as={CloseOutlineIcon}></Icon><label>You Cannot see filters on catalouge</label>
                    </Stack>
                  </Stack>
                </Panel>
              </FlexboxGrid.Item> */}


            </Form>

          </Modal.Body>
          <Modal.Footer>
            <Stack justifyContent='flex-end' >
              {/* <Button onClick={handleClose1} appearance="ghost" color='cyan'>
                Preview
              </Button> */}
              
                <Button onClick={datattt} appearance="primary" color='cyan'>
                  Generate Cataloge
                </Button>
              
            </Stack>
          </Modal.Footer>
        </Modal>

        <Modal open={open2} onClose={handleClose2} backdrop={'static'} size='full'>
          <Modal.Header>
            <Modal.Title><h4 className="title">Add More Products</h4></Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Checkbox
              checked={selectedItemsToAdd.length === data123.length}
              indeterminate={selectedItemsToAdd.length > 0 && selectedItemsToAdd.length < data123.length}
              onChange={handleSelectAll}
            >
              Select All
            </Checkbox>

            <FlexboxGrid justify="space-between" style={{ textAlign: 'center' }}>
              {data123.map((item) => (
                <FlexboxGrid.Item as={Col} colspan={24} md={6} key={item.id}>
                  <Panel className="box" bordered bodyFill style={{ display: 'inline-block', width: '100%' }}>
                    <Stack>
                      <Checkbox
                        value={item.id}
                        checked={selectedItemsToAdd.includes(item.id)}
                        onChange={(value, checked) => handleCheckboxChange(value, checked)}
                      />
                    </Stack>
                    <img src={`${ip}${item.attributes.CoverImage.data.attributes.url}`} className="imgp" />
                    <Panel>
                      <b>Product Name: {item.attributes.ProductName}</b>
                      <p>Alias Code: {item.attributes.ProductId}</p>
                    </Panel>
                  </Panel>
                </FlexboxGrid.Item>
              ))}
            </FlexboxGrid>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={handleAddItems}
              appearance="primary"
              color="cyan"
              disabled={selectedItemsToAdd.length === 0}
            >
              Done
            </Button>
          </Modal.Footer>
        </Modal>
        <Stack className="copyright" justifyContent="space-between" style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white' }}>
          <div className="container">
            <p>© All Right Reserved. Product by </p>
          </div>
          <div><p> <a href="http://hitouchtechnologies.com/" target="_blank">Hitouch Technologies (P) Ltd.</a></p></div>
        </Stack>
        <DrawerViewe open={showDrawer3} onClose={() => setShowDrawer3(false)} />
        <DrawerLink open={showDrawer2} onClose={() => setShowDrawer2(false)} />
      </Container>
    </>

  );
};

export default EditDetails;